const getters = {
  getExerciseDocumentsById: (state) => (id) => state.exerciseDocuments.find((exDocs) => exDocs.id === id)?.exerciseDocuments
};

export default getters;
